import { privateApi } from 'services/Api/ApiService';
import { LinkedinAdAccount } from './types';

const fetchLinkedinAccounts = (): Promise<LinkedinAdAccount[]> =>
    privateApi.get<LinkedinAdAccount[]>('linkedin/ad-accounts');

export const LinkedinAdAccountGateway = {
    fetchLinkedinAccounts,
};
